<template>
  <div>
    <download-excel
      :fields="json_fields"
      :fetch="startDownload"
      type="xls"
      name="合作商家订单表.xls"
    >
      <a-button type="primary" :style="{ margin: '0 0 24px 0' }">
        Excel导出
      </a-button>
    </download-excel>
    <span style="margin-left: 20px;">
      当前金额合计：{{ sumAmount }} ， 当前彩票合计：{{ sumTickets }}
    </span>
     <a-table 
      :columns="columns" 
      :data-source="data" 
      :loading="loading"
      :pagination="pagination"
      :row-key="(record) => record.objId"
      @change="handleTableChange">


  </a-table>
  </div>
</template>
<script>
import { storeGetNearbyShopOrderList,storeGetNearbyShopOrderInfo,storeGetNearbyShopOrderCount } from "@/api/storeApi.js";
import { message } from "ant-design-vue";

const columns = [
  {
    title: "订单编号",
    dataIndex: "orderNo",
    align: "center",
    key: "1",
    width:220,
  },
  {
    title: "商家名称",
    dataIndex: "partnerName",
    align: "center",
    key: "2",
  
  },

  {
    title: "商品金额",
    dataIndex: "amount",
    align: "center",
    key: "3",

  },
    {
    title: "彩票数量",
    dataIndex: "tickets",
    key: "4",
    align: "center",
  },
  {
    title: "卡号",
    dataIndex: "cardNo",
    align: "center",
    key: "5",
    width:100,

  },

  {
    title: "订单时间",
    dataIndex: "createTime",
    align: "center",
    key: "6",

  },

];


export default {
  data() {
    return {
      data: [],
      json_fields: {
        订单号: "orderNo",
        卡号: "cardNo",
        商家名称: "partnerName",
        商品金额:"amount",
        彩票数量: "tickets",
        订单时间: "createTime",
        
      },
      pagination: {
        current: 1,
        total: 0,
        showSizeChanger: true,
        pageSizeOptions: ["10", "20", "40", "80", "100"],
        showTotal: (total) => `共 ${total} 条`,
        pageSize: 10,
      },
      loading: false,
      columns,
      visible: false,
      localFormInline: {} ,// 新增：用于存储 formInline 的本地副本
      sumAmount: 0,
      sumTickets: 0,
    };
  },
  mounted() {
    // 刚点开的时候自动加载全部数据
    this.getOrderList();
  },
  props: ["formInline"],
  watch: {
    // 监听 formInline 变化并更新本地副本
    formInline: {
      handler(newVal) {
        this.localFormInline = { ...newVal };
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    topage(routerpath) {
      this.$router.push(routerpath);
    },
    onChange(checked) {
      console.log(`a-switch to ${checked}`);
    },
    // 查询
    search() {
     
      // 创建一个新的对象，清空 createTime 字段
      const queryParams = {
        ...this.localFormInline,
        createTime: null,
        page: this.pagination.current,
        limit: this.pagination.pageSize
      };
      // console.log('数据:', queryParams);
      
      this.data = [];
      this.loading = true;
      storeGetNearbyShopOrderInfo(queryParams).then((res) => {
        // console.log('请求成功，返回数据:', res);
        this.loading = false;
        if(res.data.data !=null){
          this.data = res.data.data;
          this.getCount(res.data.data);
          this.pagination.total = Number(res.data.count);

        }else{
          message.error('暂无数据');
          this.sumAmount = 0;
          this.sumTickets = 0;
        }
        
        
      }).catch((error) => {
        this.loading = false;
        console.error('请求出错:', error);
        message.error('error', error);
      });
    },
      // 添加这个方法用于导出所有数据
    async startDownload() {
      try {
        // 第一步：获取总数量，判断数据规模
        const countRes = await storeGetNearbyShopOrderList(1, 1);
        const totalCount = countRes.data.count || 0;
        
        if (totalCount === 0) {
          this.$message.warning('当前没有数据可导出');
          return [];
        }
        
        // 第二步：根据数据量决定获取策略
        let allData = [];
        
        if (totalCount <= 1000) {
          // 数据量较小，一次性获取
          const res = await storeGetNearbyShopOrderList(1, totalCount);
          allData = res.data.data || [];
        } else {
          // 数据量较大，分页获取
          const pageSize = 100;
          const totalPages = Math.ceil(totalCount / pageSize);
          
          // 提示用户正在获取数据
          const loadingMsg = this.$message.loading(`正在获取数据... 0/${totalPages}页`, 0);
          
          try {
            for (let page = 1; page <= totalPages; page++) {
              const res = await storeGetNearbyShopOrderList(page, pageSize);
              if (res.data.data && res.data.data.length > 0) {
                allData = allData.concat(res.data.data);
              }
              // 更新进度提示
              loadingMsg();
              this.$message.loading(`正在获取数据... ${page}/${totalPages}页`, 0);
            }
          } finally {
            loadingMsg();
          }
        }
        
        this.$message.success(`成功获取 ${allData.length} 条数据，开始导出...`);
        return allData;
      } catch (error) {
        this.$message.error('导出失败: ' + error.message);
        return [];
      }
    },
    // 分页按钮配置
    handleTableChange(pagination, filters, sorter) {
      console.log('分页变化:', pagination);
      this.pagination.current = pagination.current; //重置当前页
      this.pagination.pageSize = pagination.pageSize; //重置每页条数
      this.search(); //重新查询
    },

    // 获取合计
    getCount(row){
      this.sumAmount = 0;
      this.sumTickets = 0;
      if(row != null){
        this.sumAmount = row[0].sumAmount,
        this.sumTickets = row[0].sumTickets
      }
    },
 
    // 分页数据
    getOrderList() {
      this.data = [];
      // 重置分页参数并查询第一页
      this.pagination.current = 1;
    
      storeGetNearbyShopOrderList(this.pagination.current,this.pagination.pageSize).then((res) => {
        console.log('请求成功，返回数据:', res);
        if(res.data.data !=null){
          this.pagination.total = Number(res.data.count);
          this.data = res.data.data;
          this.getCount(res.data.data);
        }else{
          message.error('暂无数据');
          this.sumAmount = 0;
          this.sumTickets = 0;
        }

      }).catch((error) => {
        console.error('请求出错:', error);
      });
    },
    showModal() {
      this.visible = true;
    },
    handleOk(e) {
      console.log(e);
      this.visible = false;
    },

   

  },
};
</script>
<style scoped>
.test {
  position: relative;
  left: 55px;
}

#components-table-demo-summary tfoot th,
#components-table-demo-summary tfoot td {
  background: #fafafa;
}
[data-theme='dark'] #components-table-demo-summary tfoot th,
[data-theme='dark'] #components-table-demo-summary tfoot td {
  background: #1d1d1d;
}
</style>


// WEBPACK FOOTER //
// src/views/orderManagement/partnerOrderTwo/partnerOrderContentTwo.vue